import QRCode from "react-qr-code";
import { toast } from "react-toastify";
import copyText from "@/core/helpers/copyText";
import useAppSelector from "@/core/helpers/useAppSelector";
import { DiscrodIcon, PowerIcon, TelegramIcon, VkIcon, YoutubeIcon } from "@/shared/icons";
import { BaseIcon } from "@/shared/icons/BaseIcon";
import { Button, SoundButton } from "@/shared/ui";
import { playerInfoSelector } from "@/domains/player/slice";
import PlayerMenuSocialTooltip from "@/domains/playerMenu/components/PlayerMenuSocialTooltip";
import PlayerMenuMoney from "@/domains/playerMenu/components/playerInfo/PlayerMenuMoney";
import PlayerMenuPassLevel from "@/domains/playerMenu/components/playerInfo/PlayerMenuPassLevel";
import PlayerMenuPlayerInfo from "@/domains/playerMenu/components/playerInfo/PlayerMenuPlayerInfo";
import PlayerMenuPremiumRegion from "@/domains/playerMenu/components/playerInfo/PlayerMenuPremiumRegion";
import PlayerMenuPrimialCoin from "@/domains/playerMenu/components/playerInfo/PlayerMenuPrimialCoin";
import PlayerMenuTopUpBalance from "@/domains/playerMenu/components/playerInfo/PlayerMenuTopUpBalance";

const socialLinks: { icon: typeof BaseIcon; href: string }[] = [
  { icon: TelegramIcon, href: "https://t.me/region" },
  { icon: DiscrodIcon, href: "https://discord.gg/regiononline" },
  { icon: VkIcon, href: "https://vk.com/regiononline" },
  { icon: YoutubeIcon, href: "https://youtube.com/@region_online" },
];

export default function PlayerMenuPlayerInfoContainer() {
  const playerInfo = useAppSelector(playerInfoSelector);

  if (!playerInfo) return null;

  return (
    <div className="w-[25rem] h-full flex flex-col shrink-0">
      {playerInfo?.character && (
        <>
          <PlayerMenuPlayerInfo
            name={playerInfo.character.name.content}
            id={playerInfo.character.id}
            level={playerInfo.player.level}
          />
          <PlayerMenuMoney
            bank={playerInfo.character.money.bank}
            balance={playerInfo.character.money.balance}
          />
        </>
      )}
      <PlayerMenuPrimialCoin value={playerInfo?.user?.donateCoins || 0} />
      <PlayerMenuTopUpBalance />
      <div className="relative grow mt-2">
        <div className="absolute inset-0 px-10 overflow-y-auto">
          <PlayerMenuPremiumRegion />
          <PlayerMenuPassLevel />
        </div>
      </div>
      <div className="flex items-center gap-2 px-10 pb-8">
        {socialLinks.map((item) => (
          <PlayerMenuSocialTooltip
            key={item.href}
            content={<QRCode size={128} value={item.href} bgColor="transparent" fgColor="white" />}
          >
            <Button
              className="h-[2.375rem] aspect-square shrink-0 p-0 bg-dark-800 rounded-[0.625rem]"
              variant="ghost"
              color="gray"
              onClick={() => {
                copyText(item.href);
                toast.success("Ссылка скопирована в буфер обмена");
              }}
            >
              {item.icon({ size: 18 })}
            </Button>
          </PlayerMenuSocialTooltip>
        ))}

        <SoundButton
          className="h-[2.375rem] aspect-square shrink-0 p-0 bg-dark-800 rounded-[0.625rem] grow gap-2 hover:text-accent-solid"
          variant="link"
          color="gray"
        >
          <PowerIcon size={18} />
          Выйти
        </SoundButton>
      </div>
    </div>
  );
}
